module.exports = __webpack_public_path__ + "static/media/sb.c8e9b05f.svg";